import * as React from "react";
import { Input } from "./input";
import { Textarea } from "./textarea";
import { Label } from "./label";
import { LANGUAGES, type Lang } from "@/app/i18n/types";
import { cn } from "@/app/utils/tw-merge";

/** Multilingual field — render 3 input/textarea theo vi/en/ja, chỉ hiện
 *  input của ngôn ngữ đang chọn (lang). Dùng khi sửa metadata localizable
 *  { vi, en, ja }. */
export function MlField({
  base,
  lang,
  label,
  placeholder,
  area,
  className,
  inputClassName,
  textareaClassName,
  value,
  onChange,
}: {
  base: string;
  lang: Lang;
  label: string;
  placeholder?: string;
  area?: boolean;
  className?: string;
  inputClassName?: string;
  textareaClassName?: string;
  value: Partial<Record<Lang, string>>;
  onChange: (next: Partial<Record<Lang, string>>) => void;
}) {
  return (
    <Label className={className}>
      <span className="text-xs font-medium text-muted-foreground">{label}</span>
      {LANGUAGES.map((lg) => {
        const v = value[lg] ?? "";
        const hidden = lg !== lang;
        if (area) {
          return (
            <Textarea
              key={lg}
              id={`${base}__${lg}`}
              data-lang={lg}
              placeholder={placeholder ?? lg.toUpperCase()}
              hidden={hidden}
              value={v}
              onChange={(e) => onChange({ ...value, [lg]: e.target.value })}
              className={cn("min-h-24", textareaClassName)}
            />
          );
        }
        return (
          <Input
            key={lg}
            id={`${base}__${lg}`}
            data-lang={lg}
            placeholder={placeholder ?? lg.toUpperCase()}
            hidden={hidden}
            value={v}
            onChange={(e) => onChange({ ...value, [lg]: e.target.value })}
            className={inputClassName}
          />
        );
      })}
    </Label>
  );
}

export function useMlField(
  initial?: Partial<Record<Lang, string>>
): [Partial<Record<Lang, string>>, (next: Partial<Record<Lang, string>>) => void] {
  const [v, setV] = React.useState<Partial<Record<Lang, string>>>(initial ?? {});
  return [v, setV];
}
